import React from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { useApiClient } from '../api/client';
import { getMyRideRequests, RideRequestSummaryDto } from '../api/client';
import { formatDateTime } from '../utils/dateFormat';

export const RideRequestsListPage: React.FC = () => {
  const { t } = useI18n();
  const { request } = useApiClient();
  const [items, setItems] = React.useState<RideRequestSummaryDto[] | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getMyRideRequests(request)
      .then((res) => { if (!cancelled) setItems(res); })
      .catch((e) => { if (!cancelled) setError(String(e.message || e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [request]);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-extrabold">{t('rideRequest.title')}</h1>
      </div>
      {loading && <div className="text-sm text-gray-600">{t('common.loading')}</div>}
      {error && <div className="text-sm text-red-700">{t('common.error')}: {error}</div>}
      {items && items.length === 0 && (
        <div className="rounded border bg-white p-4 text-sm text-gray-700">No ride requests yet.</div>
      )}
      {items && items.length > 0 && (
        <ul className="grid gap-2">
          {items.map((r) => (
            <li key={r.id} className="rounded border bg-white p-4">
              <div className="flex items-center justify-between">
                <div className="font-semibold">{formatDateTime(r.time)}</div>
                <span className="text-xs rounded bg-gray-100 px-2 py-1">{r.status}</span>
              </div>
              <div className="text-sm text-gray-700 mt-1">
                <div>From: {r.departure.publicName}</div>
                <div>To: {r.destination.publicName}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RideRequestsListPage;

